import * as React from 'react';

// react-routers components
import {Link} from "react-router-dom";
// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import UserInformation from "../../../../layouts/profile/userInformation/UserInformation";
import UserEmailEdit from "../../../../layouts/profile/userInformation/UserEmailEdit";
import PaperComponent from "../../../../components/MuiDraggableDialog";
import {useDispatch} from "react-redux";
import LocalStorage from "../../../../utils/LocalStorage";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";

function ProfileInfoCard({title, description, userInfo, info, social, action, shadow, getUserInfoFetch}) {
    const labels = [];
    const values = [];
    let indexOfEmail
    let indexOfMobile
    const {socialMediaColors} = colors;
    const {size} = typography;
    const {t} = useTranslation();


    // Convert this form `objectKey` of the object key in to this `object key`
    Object.keys(info).forEach((el) => {
        if (el.match(/[A-Z\s]+/)) {
            const uppercaseLetter = Array.from(el).find((i) => i.match(/[A-Z]+/));
            const newElement = el.replace(uppercaseLetter, ` ${uppercaseLetter.toLowerCase()}`);

            labels.push(newElement);
        } else {
            labels.push(el);
        }
    });

    // Push the object values into the values array
    Object.values(info).forEach((el) => values.push(el));


    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const getLabelText = (label) =>{
        return t(`AccountPage.${label}`)
    }

    // Render the card info items
    const renderItems =
        <MDBox>
            {
                !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                labels.map((label, key) => {
                    indexOfEmail = 4
                    return (
                        <MDBox key={label} display="flex" py={1} pr={2} alignItems="center">
                            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                                {getLabelText(label)}: &nbsp;
                            </MDTypography>

                            {
                                (label === "email" && checkPermission(PERMISSION_DICT.AccountEmailModify))?
                                    <div style={{
                                        display: "flex",
                                        fontSize: "15px",
                                        cursor: "pointer",
                                        alignItems: "center"
                                    }}
                                         onClick={() => {
                                             setOpenEmailEdit(true)
                                         }}
                                    >
                                        <MDTypography variant="button" fontWeight="regular" color="primary">
                                            &nbsp; {validateEmail(values[key]) ? values[key] : "Link new Email"}
                                        </MDTypography>
                                        <Icon>edit</Icon>
                                    </div>

                                    :
                                    <MDTypography variant="button" fontWeight="regular" color="text">
                                        &nbsp;{values[key]}
                                    </MDTypography>
                            }
                            {/*{*/}
                            {/*    label === "email" &&*/}
                            {/*    <div style={{display:"flex",position: "absolute", right: "15px", fontSize:"15px", cursor:"pointer"}}>*/}
                            {/*      <MDTypography variant="button" fontWeight="regular" color="text">*/}
                            {/*        edit*/}
                            {/*      </MDTypography>*/}
                            {/*    </div>*/}
                            {/*}*/}

                        </MDBox>
                    )

                })
            }

          {
              checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
              labels.map((label, key) => {
                indexOfMobile = 3
                indexOfEmail = 4
                return (
                    (label === "email" || label === "mobile") &&
                    <MDBox key={label} display="flex" py={1} pr={2} alignItems="center">
                      <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                        {getLabelText(label)}: &nbsp;
                      </MDTypography>

                      {
                          (label === "email" && checkPermission(PERMISSION_DICT.AccountEmailModify))?
                            <div style={{
                              display: "flex",
                              fontSize: "15px",
                              cursor: "pointer",
                              alignItems: "center"
                            }}
                                 onClick={() => {
                                   setOpenEmailEdit(true)
                                 }}
                            >
                              <MDTypography variant="button" fontWeight="regular" color="primary">
                                &nbsp; {validateEmail(values[key]) ? values[key] : "Link new Email"}
                              </MDTypography>
                              <Icon>edit</Icon>
                            </div>

                            :
                            <MDTypography variant="button" fontWeight="regular" color="text">
                              &nbsp;{values[key]}
                            </MDTypography>
                      }
                    </MDBox>
                )

              })
          }
            {/*{role !== 'admin' &&*/}
            {/*    <MDBox display="flex" py={1} pr={2} alignItems="center">*/}
            {/*        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">*/}
            {/*            Carriers: &nbsp;*/}
            {/*        </MDTypography>*/}
            {/*        <div style={{display: "flex", fontSize: "15px", cursor: "pointer", alignItems: "center"}}*/}
            {/*             onClick={() => {*/}
            {/*                 dispatch(getUserSetting())*/}
            {/*                 setOpenCarrierEdit(true)*/}
            {/*             }}*/}
            {/*        >*/}
            {/*            <MDTypography variant="button" fontWeight="regular" color="primary">*/}
            {/*                &nbsp;View Details*/}
            {/*            </MDTypography>*/}
            {/*            <Icon>edit</Icon>*/}
            {/*        </div>*/}

            {/*    </MDBox>*/}
            {/*}*/}

        </MDBox>

    // Render the card social media icons
    const renderSocial = social.map(({link, icon, color}) => (
        <MDBox
            key={color}
            component="a"
            href={link}
            target="_blank"
            rel="noreferrer"
            fontSize={size.lg}
            color={socialMediaColors[color].main}
            pr={1}
            pl={0.5}
            lineHeight={1}
        >
            {icon}
        </MDBox>
    ));

    const [openDetail, setOpenDetail] = React.useState(false);
    const [openEmailEdit, setOpenEmailEdit] = React.useState(false);

    const [openCarrierEdit, setOpenCarrierEdit] = React.useState(false);


    return (
        <React.Fragment>
            <Card sx={{height: "100%", width: "100%", boxShadow: !shadow && "none"}}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        {title}
                    </MDTypography>
                    {
                        !checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                        <MDTypography component={Link} to={action.route} variant="body2" color="secondary">
                            <Tooltip title={action.tooltip} placement="top">
                                <Icon onClick={() => {
                                    setOpenDetail(true)
                                }}>more_horiz</Icon>
                            </Tooltip>
                        </MDTypography>
                    }

                </MDBox>
                <MDBox p={2}>
                    <MDBox mb={2} lineHeight={1}>
                        <MDTypography variant="button" color="text" fontWeight="light">
                        </MDTypography>
                    </MDBox>
                    <MDBox opacity={0.3}>
                        <Divider/>
                    </MDBox>
                    <MDBox>
                        {renderItems}
                        {/*<MDBox display="flex" py={1} pr={2}>*/}
                        {/*    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">*/}
                        {/*        social: &nbsp;*/}
                        {/*    </MDTypography>*/}
                        {/*    {renderSocial}*/}
                        {/*</MDBox>*/}
                    </MDBox>
                </MDBox>
            </Card>


            <Dialog
                PaperComponent={PaperComponent}
                fullWidth={true}
                maxWidth={'xl'}
                open={openDetail}
                onClose={() => {
                    setOpenDetail(false)
                }}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title" style={{cursor: 'move'}}>
                    {t("AccountPage.User Information Detail")}
                </DialogTitle>
                <DialogContent>
                    <UserInformation setOpen={setOpenDetail}/>
                </DialogContent>
                {/*<DialogActions>*/}
                {/*  <Button onClick={handleClose}>Disagree</Button>*/}
                {/*  <Button onClick={handleClose} autoFocus>*/}
                {/*    Agree*/}
                {/*  </Button>*/}
                {/*</DialogActions>*/}
            </Dialog>


            <Dialog
                fullWidth={true}
                maxWidth={'xs'}
                open={openEmailEdit}
                onClose={() => {
                    setOpenEmailEdit(false)
                }}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            ><DialogTitle id="draggable-dialog-title" style={{cursor: 'move'}}>
                <MDTypography variant={'h5'}>
                </MDTypography>
            </DialogTitle>
                <DialogContent>
                    <div style={{marginTop: "30px"}}>
                        <UserEmailEdit setOpen={setOpenEmailEdit} originalEmail={info?.email}
                                       isNew={!validateEmail(values[indexOfEmail])}
                                       getUserInfoFetch={getUserInfoFetch}/>
                    </div>
                </DialogContent>
            </Dialog>
            {/*<UserCarrierEdit setOpen={setOpenCarrierEdit} open={openCarrierEdit} userInfo={userInfo}*/}
            {/*                 parent={"userInfo"}/>*/}
        </React.Fragment>
    );
}

// Setting default props for the ProfileInfoCard
ProfileInfoCard.defaultProps = {
    shadow: true,
};

// Typechecking props for the ProfileInfoCard
ProfileInfoCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    info: PropTypes.objectOf(PropTypes.string).isRequired,
    social: PropTypes.arrayOf(PropTypes.object).isRequired,
    action: PropTypes.shape({
        route: PropTypes.string.isRequired,
        tooltip: PropTypes.string.isRequired,
    }).isRequired,
    shadow: PropTypes.bool,
};

export default ProfileInfoCard;
